/*
 * The spouse-reached-retirement-age conversation (GC-3489).
 *
 * The Home alert that fires when an included spouse crossed their retirement
 * age since the last login offers two pills:
 *
 *   "Learn more"            → the approved help text, verbatim. It is the same
 *                             copy the alert card puts behind its help icon.
 *                             On the wide Home the card is not rendered at all
 *                             (the chat panel replaces it), so without this the
 *                             explanation of WHY the goal changed and WHERE to
 *                             update it would be unreachable on desktop.
 *   "Update my income goal" → NOT answered here; it goes to the agent like any
 *                             other pill. The design specifies client-side
 *                             behaviour only for "Learn more".
 *
 * Nothing here creates a chat, calls the agent, or persists a message — the
 * exchange lives in the client-only turn list above the transcript (ChatView's
 * `leadingTurns`), exactly as the salary exchange does.
 *
 * NOTE: "Learn more" is also one of salaryPrompt's labels. The two exchanges are
 * mutually exclusive by construction — homeChatDefaults.homeChatPrompt picks one
 * owner for the pills, and both surfaces gate their hooks on it — so only one
 * `handle` is ever live to intercept that word.
 */

export const SPOUSE_GOAL_PILL_UPDATE = 'Update my income goal'
export const SPOUSE_GOAL_PILL_LEARN_MORE = 'Learn more'

/*
 * The alert's starter pills. Defined here, beside the behaviour they trigger,
 * for the same reason salaryPrompt keeps its own: a label that drifts from what
 * `useSpouseGoalPrompt` matches on is a pill that silently falls through to the
 * agent, which is the failure this module exists to prevent.
 */
export const SPOUSE_GOAL_SUGGESTIONS = [SPOUSE_GOAL_PILL_UPDATE, SPOUSE_GOAL_PILL_LEARN_MORE]

/*
 * The help content exactly as signed off, minus the parenthetical aside about
 * expanding the menu — the sidebar icons carry hover states now, so the click
 * instruction it described is no longer needed (and never made sense as chat
 * text). Kept as one string, headings included, so the bubble reads the way the
 * tooltip does; ChatView bubbles are pre-wrap.
 */
export const SPOUSE_GOAL_HELP_TEXT = [
  'While your spouse earned income prior to retiring, GuidedChoice bases its projected income on income currently earning only. Since you are likely used to living off a combined total of take-home pay, we suggest changing your income goal accordingly.',
  'If your spouse has not retired, you can go to your profile to update their retirement age.',
  'Where to change income goal\nIn the menu on the left, under Goals, select “Percent of income seeking after retiring.”',
].join('\n\n')
